import { useLazyQuery } from "@apollo/client/react"; import { useEffect, useState } from "react";
import { useDebounce } from "./useDebounce";


export default function useSearchGridData({
  entityId,
  entityName,
  query,
  adapter,
  getSearchParams,
  handleChangeEntityValue,
  entityIdValue,
  multiple,
  entityIdValues,
  setRowValues,
  orderBy
}) {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [textFilter, setTextFilter] = useState('');

  const debouncedTextFilter = useDebounce(textFilter, 1000);
  const [getData, { loading: responseLoading }] = useLazyQuery(query, {
    fetchPolicy: 'network-only'
  });

  const [getSelectedData] = useLazyQuery(query, {
    fetchPolicy: 'network-only'
  });

  useEffect(() => {//Responsable de traer el dato de la entidad en caso de existencia
    if (!entityIdValue) return;
    getSelectedEntity();
  }, [entityIdValue]);

  useEffect(() => {//Responsable de traer los datos de las rows seleccionadas en caso de existencia
    if (!multiple) return;

    if (!entityIdValues?.length) return setRowValues([]);

    getSelectedRows();
  }, [entityIdValues]);

  useEffect(() => {//Responsable de traer la data para la grilla
    getData({
      variables: {
        skip: page * pageSize,
        take: pageSize,
        where: getSearchParams(debouncedTextFilter),
        order: [{
          [orderBy?.fieldName]: orderBy?.order?.toUpperCase()
        }]
      }
    }).then(({ data }) => {
      setRows(data);
    }).catch((err) => { console.log(err) });
  }, [debouncedTextFilter, page, pageSize, getSearchParams, orderBy]);

  const getSelectedEntity = async () => {
    await getSelectedData({
      variables: {
        skip: 0,
        take: 1,
        where: {
          [entityId]: { eq: entityIdValue }
        },
        order: [{
          [orderBy?.fieldName]: orderBy?.order?.toUpperCase()
        }]
      }
    }).then(({ data }) => {
      const row = adapter(data?.[entityName]?.items)?.at();
      handleChangeEntityValue(row);
    }).catch((err) => { console.log(err) });
  };

  const getSelectedRows = async () => {
    const searchParams = entityIdValues.map((id) => ({ [entityId]: { eq: id } }));
    await getSelectedData({
      variables: {
        where: {
          or: [...searchParams]
        },
        order: [{
          [orderBy?.fieldName]: orderBy?.order?.toUpperCase()
        }]
      }
    }).then(({ data }) => {
      const selectedRows = adapter(data?.[entityName]?.items);
      setRowValues(selectedRows);
    }).catch((err) => { console.log(err) });
  };

  const onPageChange = (newPage) => {
    setPage(newPage);
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
  };
  return {
    rows: adapter(rows?.[entityName]?.items || []),
    responseLoading,
    totalCount: rows?.[entityName]?.totalCount,
    page,
    pageSize,
    textFilter,
    onChangeFilter: setTextFilter,
    onPageChange,
    onPageSizeChange
  };
}